import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "./AuthContext";

function Confirmation() {
  const location = useLocation();
  const navigate = useNavigate();
  const { product, address } = location.state || {}; // Safely access state
  const { Useraddress, UserselectedProduct } = useAuth();
  const [products, setProducts] = useState(null); // Initialize as null

  useEffect(() => {
    if (product && address) {
      setProducts({ product, address });
    }
  }, [product, address]);

  const handleProceedToPayment = () => {
    if (products) {
      navigate("/payment", { state: { product, address } });
    }
  };

  console.log('address', Useraddress);
  console.log('selected Product', UserselectedProduct);

  if (!products) {
    return <p className="text-center mt-4">Loading product details... Please go back and try again.</p>;
  }

  return (
    <div className="container mx-auto p-6 md:p-12 bg-gray-100 rounded-lg shadow-lg w-full h-full">
      <h1 className="text-3xl font-bold text-center mb-6 text-gray-800">Order Confirmation</h1>
      <div className="mt-4 bg-white p-6 rounded-lg shadow-md">
        <h2 className="text-xl font-semibold text-gray-800">Product Details</h2>
        <p className="text-gray-700">Name: <span className="font-medium">{products.product?.name || "N/A"}</span></p>
        <p className="text-gray-700">Price: <span className="font-medium">${products.product?.price?.toFixed(2) || "0.00"}</span></p>

        <h2 className="text-xl font-semibold text-gray-800 mt-4">Shipping Information</h2>
        <p className="text-gray-700">
          Address: {products.address?.street}, {products.address?.city}, {products.address?.state} - {products.address?.pincode}
        </p>

        <button
          onClick={handleProceedToPayment}
          className="mt-6 w-full bg-black text-white py-2 rounded-lg hover:bg-gray-800 transition duration-300 ease-in-out"
        >
          Proceed to Payment
        </button>
      </div>
    </div>
  );
}

export default Confirmation;
